import { render, staticRenderFns } from "./AiSyntaxPromptEditor.vue?vue&type=template&id=3bd6f467&scoped=true&"
import script from "./AiSyntaxPromptEditor.vue?vue&type=script&lang=ts&"
export * from "./AiSyntaxPromptEditor.vue?vue&type=script&lang=ts&"
import style0 from "./AiSyntaxPromptEditor.vue?vue&type=style&index=0&id=3bd6f467&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd6f467",
  null
  
)

export default component.exports